// Module
var code = `<ex-multi-occurrence-analyse lbl-titre="LBL_BLC_DAE" multi-occurrence-options="vm.multiOccurrenceOptions"> </ex-multi-occurrence-analyse> `;
// Exports
module.exports = code;